import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

const StatusBoxSC = styled.div<{ $active?: boolean | null; $customColor?: CustomColorT }>(
  ({ $active, theme, $customColor }) => {
    let color: { txt: string; bg: string };
    switch ($customColor) {
      case 'red':
        color = { txt: theme.red.a10, bg: theme.red.a1 };
        break;
      case 'green':
        color = { txt: theme.green.a10, bg: theme.green.a1 };
        break;
      case 'blue':
        color = { txt: theme.lightBlue.a10, bg: theme.lightBlue.a1 };
        break;
      case 'yellow':
        color = { txt: theme.gold.a10, bg: theme.gold.a1 };
        break;
      default:
        color = {
          txt: $active ? theme.green.a10 : theme.lightBlue.a10,
          bg: $active ? theme.green.a1 : theme.lightBlue.a1,
        };
    }
    return css`
      font-size: 0.8rem;
      font-weight: 600;
      padding: 6px 12px;
      border-radius: 3px;
      text-transform: uppercase;
      color: ${color.txt};
      background-color: ${color.bg};
    `;
  },
);
export type CustomColorT = 'red' | 'green' | 'blue' | 'yellow';

interface Props {
  active?: boolean | null;
  customColor?: CustomColorT;
  customKey?: string;
  style?: { [key: string]: string | number };
  /** Partial text key assuming it would be with suffixes: .active | .inactive */
  txtKeyPartial?: string;
}

const StatusBox: FC<Props> = ({ active, style, txtKeyPartial = 'x.surveys.schedules.listitem.activebox', customKey, customColor }) => {
  const [t] = useTranslation();
  const txtKey = customKey || `${txtKeyPartial}.${active ? 'active' : 'draft'}`;

  return (
    <StatusBoxSC className="button_text" $active={active} style={style} $customColor={customColor}>
      <span data-translation={txtKey}>
        <>{t(txtKey)}</>
      </span>
    </StatusBoxSC>
  );
};

export default StatusBox;
